import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Scale } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/services/corporate-lawyer", label: "Services" },
  { to: "/cases", label: "Case Experience" },
  { to: "/blog", label: "Insights" },
  { to: "/book", label: "Book Consult" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="glass fixed top-0 left-0 right-0 z-50 border-b border-slate-200/60"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <div className="relative w-12 h-12 flex-shrink-0 rounded-full bg-gradient-to-br from-[#0A2540] via-[#1E3A8A] to-[#1D4ED8] shadow-md ring-1 ring-[#93C5FD]/30 flex flex-col items-center justify-center">
            <Scale size={18} className="text-white mb-0.5" strokeWidth={1.75} />
            <div className="h-px w-5 bg-[#93C5FD]/60"></div>
            <span className="font-serif text-[9px] text-[#93C5FD] tracking-[0.3em] font-semibold mt-0.5 leading-none">SM</span>
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg text-[#0A2540] font-semibold">Shubham Makkar</div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#1D4ED8] font-medium">
              Advocate · Chandigarh
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-5 lg:gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm link-underline tracking-wide font-medium whitespace-nowrap ${isActive ? "text-[#1D4ED8]" : "text-slate-600 hover:text-[#0A2540]"
                }`
              }
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <Link to="/book" className="primary-btn text-sm" data-testid="navbar-book-btn">
            Book Consultation
          </Link>
        </div>

        <button
          className="md:hidden text-[#0A2540]"
          onClick={() => setOpen(!open)}
          data-testid="navbar-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="flex flex-col p-6 gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-slate-700 text-base py-3 border-b border-slate-100"
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              className="primary-btn justify-center mt-4"
              data-testid="mobile-book-btn"
            >
              Book Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
